import { CommonModalDataType } from '../type/CommonModalData.type';

export const commonModalContentInitialize: CommonModalDataType = {
    show: false,
    title: '',
    contentType: null,
    displayModalText: '',
}